/* global modForm Modalytics grecaptcha */
import { preventRecaptchaFileLoad } from './preventRecaptchaFileLoad';
import { recaptchaChallengeObserver } from './recaptchaChallengeObserver';

/**
 * Renders the reCAPTCHA widget once the script is loaded and sets up token/expiry callbacks.
 * Skips rendering for non-direct-traffic and non-default-quad scenarios.
 * @returns {void}
 */
export function onRecaptchaLoad() {
	if (!modForm.opts.isDirectTraffic && !modForm.opts.usingDefaultQuad) {
		preventRecaptchaFileLoad();
		return;
	}

	const $challenge = document.querySelector('[title*=challenge]');
	if ($challenge) {
		$challenge.parentElement?.parentElement?.remove();
	}
	recaptchaChallengeObserver();

	grecaptcha.ready(function() {
		modForm.opts.isRecaptchaScriptLoaded = true;
		if (modForm.opts.recaptchaContainer?.children.length) {
			return;
		}
		grecaptcha.render('recaptcha-container', {
			sitekey: window.__recaptchaKey,
			callback: function(token) {
				window.rcptToken = token;
				if (modForm.opts.recaptchaField) {
					modForm.opts.recaptchaField.value = token;
					modForm.opts.recaptchaField.closest('.form-group')?.classList.remove('has-error');
				}
			},
			'error-callback': function(error) {
				Modalytics.heap('track', ['Token Error', {
					token: 'reCaptcha',
					errorMessage: 'Could not render: ' + window.__recaptchaKey + ', ' + error
				}]);
			},
			'expired-callback': function() {
				window.rcptToken = '';
				if (modForm.opts.recaptchaField) {
					modForm.opts.recaptchaField.value = '';
				}
			}
		});
	});
}
